import React from "react";
import { StyledDataGrid, DataTableDivContainer } from "./DataGridRange.style";

const DataGridRange = (props) => {
  return (
    <DataTableDivContainer>
      {/* <Box sx={{ boxShadow: 2, width: "100%" }}> */}
      <StyledDataGrid
        rows={props.rows}
        columns={props.columns}
        pageSize={props.pageSize}
        rowsPerPageOptions={props.pageSizeOptions}
        onPageSizeChange={props.onPageSizeChange}
        totalRowCount={props.totalDevices}
        disableSelectionOnClick
        showColumnRightBorder={false}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        disableColumnSelector={true}
        componentsProps={{
          toolbar: {
            header: props.toolbarHeader,
            filterPlaceholder: props.toolbarFilterPlaceholder,
            buttonConfigs:[]
          },
        }}
      />
      {/* </Box> */}
    </DataTableDivContainer>
  );
};

export default DataGridRange;
